import axios from 'Services/axiosInterceptor';
import { externalBaseUrl } from '../../../../configs/constants';

function removeUndefinedObject(obj) {
  for (const key in obj) {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  }
  return obj;
}

export const exportInvoiceMonthlyReport = (search = {}) => {
  var obj = {
    location_id_in: search?.outlet,
    date_lteq: search?.start_date,
    date_gteq: search?.end_date,
    e_invoice_status_eq: search?.status,
  };
  obj = removeUndefinedObject(obj);
  var queryString = Object.keys(obj).map(key => key + "=" + encodeURIComponent(obj[key])).join("&");

  return axios.get(`${externalBaseUrl}/e-invoice/export-monthly-report?${queryString}`, { responseType: 'blob'});
};